// biome-ignore lint/style/noRestrictedImports: legacy code - style/noRestrictedImports
import styled from 'styled-components';

import {
  DEFAULT_TRANSLATION_DESKTOP,
  DEFAULT_TRANSLATION_MOBILE,
  ITEM_DESKTOP_FULL_WIDTH,
  ITEM_DESKTOP_HEIGHT,
  ITEM_DESKTOP_MARGIN,
  ITEM_DESKTOP_WIDTH,
  ITEM_MOBILE_FULL_WIDTH,
  ITEM_MOBILE_HEIGHT,
  ITEM_MOBILE_MARGIN,
  ITEM_MOBILE_WIDTH,
} from './constants';

export const Wrapper = styled.div`
  height: 600px;
`;

export const ItemContainer = styled.button<{ isSelected: boolean }>`
  position: relative;
  border-radius: 10px;
  width: ${ITEM_MOBILE_WIDTH}px;
  margin-right: ${ITEM_MOBILE_MARGIN}px;
  height: ${ITEM_MOBILE_HEIGHT}px;
  background: rgba(0, 0, 0, 0.7);

  box-shadow: ${({ isSelected }) =>
    isSelected
      ? '0px 0 20px rgba(112, 78, 246, 0.8);-webkit-box-shadow: 0px 0 20px rgba(112, 78, 246, 0.8);-moz-box-shadow: 0px 0 20px rgba(112, 78, 246, 0.8);'
      : 'none'};
  will-change: transform;
  transform: ${({ isSelected }) => (isSelected ? 'scale(1.2)' : 'none')};
  z-index: ${({ isSelected }) => (isSelected ? 3 : 2)};
  opacity: ${({ isSelected }) => (isSelected ? 1 : 0.4)};
  transition: 0.3s;
  ::after {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 10px;
    box-shadow: ${({ isSelected }) =>
      isSelected
        ? '0 0 3px rgba(112, 78, 246, 1) inset; -webkit-box-shadow: 0 0 3px rgba(112, 78, 246, 1) inset; -moz-box-shadow: 0 0 3px rgba(112, 78, 246, 1) inset; '
        : 'none'};

    border: ${({ isSelected }) =>
      isSelected ? '1px solid rgba(112, 78, 246, 0.6)' : 'none'};
    /* transform: ${({ isSelected }) =>
      isSelected ? 'scale(1.2)' : 'none'}; */
  }
  ::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 10px;
    z-index: -1;
    box-shadow: ${({ isSelected }) =>
      isSelected ? ' 0px 0px 24px rgba(255, 255, 255, 0.22);' : 'none'};
  }

  ${({ theme }) => theme.breakpoints.up('sm')} {
    width: ${ITEM_DESKTOP_WIDTH}px;
    margin-right: ${ITEM_DESKTOP_MARGIN}px;
    height: ${ITEM_DESKTOP_HEIGHT}px;
  }
`;

export const IconWrapper = styled.span`
  svg {
    width: 20px;
    height: 20px;
    stroke-width: 2px;
    path {
      fill: white;
      transition: 0.4s;
    }
  }
`;

export const SliderContainer = styled.div`
  width: ${ITEM_MOBILE_FULL_WIDTH * 3 - ITEM_MOBILE_MARGIN}px;
  box-sizing: content-box;
  ${({ theme }) => theme.breakpoints.up('sm')} {
    width: ${ITEM_DESKTOP_FULL_WIDTH * 5 - ITEM_DESKTOP_MARGIN}px;
  }
`;

export const DraggableContentContainer = styled.div<{
  translateX: number | 'default';
}>`
  transform: translateX(
    ${({ translateX }) =>
      translateX === 'default' ? DEFAULT_TRANSLATION_MOBILE : translateX}px
  );
  ${({ theme }) => theme.breakpoints.up('sm')} {
    transform: translateX(
      ${({ translateX }) =>
        translateX === 'default' ? DEFAULT_TRANSLATION_DESKTOP : translateX}px
    );
  }
  will-change: transform;
  transition: 0.3s;
`;
